<template>
  <div
    class="tw-container tw-mx-auto tw-mt-0 tw-mb-0 tw-px-4 lg:tw-mt-4 lg:tw-mb-4"
  >
    <ul
      class="tw-flex tw-body-small tw-items-center tw-flex-nowrap tw-overflow-hidden tw-py-3 lg:tw-py-0"
    >
      <li
        v-for="item in items"
        :key="`breadcrumb-${item.path}`"
        class="tw-flex tw-items-center tw-min-w-0 tw-max-w-[200px]"
        :class="{
          'tw-flex-shrink-0': item.path,
          'tw-flex-1': !item.path,
        }"
      >
        <span
          v-if="item.path"
          class="tw-flex tw-items-center tw-min-w-0 tw-max-w-full"
        >
          <NuxtLink
            :to="item.path"
            :title="item.title"
            class="tw-block tw-max-w-full tw-truncate tw-whitespace-nowrap tw-text-black hover:!tw-text-primary tw-transition-colors tw-duration-300"
          >
            {{ item.title }}
          </NuxtLink>
          <QIcon name="chevron_right" class="tw-px-1 tw-flex-shrink-0" />
        </span>
        <span
          v-else-if="!item.path"
          class="tw-block tw-max-w-full tw-text-dark-gray tw-truncate tw-whitespace-nowrap"
        >
          {{ item.title }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
interface BreadcrumbItem {
  title: string
  path?: string
}

defineProps({
  items: {
    type: Array as () => BreadcrumbItem[],
    default: () => ([]),
  },
})
</script>
